// extracted by mini-css-extract-plugin
export default {"main":"SongPollResults_main__68tW1"};